module.exports = __webpack_public_path__ + "static/media/errorSevere-buzzer.fe461fda.mp3";